import React from 'react';
import isNil from 'lodash/isNil';
import { Link } from 'react-router-dom';
import BaseCell from './BaseCell';

const LinkCell = ({
  to, hideLink = false, children, openInNewTab = true, hideIcon = false, ...props
}) => {
  const linkProps = openInNewTab ? { target: '_blank' } : {};
  const showIcon = !hideIcon && openInNewTab && !(isNil(to) && isNil(children));

  return (
    <BaseCell {...props} selectable={false}>
      {!hideLink && (
        <Link className='base-link' to={to} {...linkProps}>
          {children}
          {showIcon && <span className='k-icon k-i-hyperlink-open-sm' />}
        </Link>
      )}
    </BaseCell>
  );
};

export default LinkCell;
